import React from 'react'
import '../styles/d3/checkbox.scss'

const Checkbox = props => {
  const {
    disabled,
    onClick,
    checked,
    label,
    toggle,
    stopPropagation,
    check = false,
    transition = false,
    className,
  } = props

  const _className = `${className ? `${className} ` : ''}${
    toggle ? 'toggle' : 'checkbox'
  } ${disabled ? 'disabled' : ''}`
  const _onClick = e => {
    if (stopPropagation) e.stopPropagation()
    onClick()
  }
  const disabledClass = disabled ? ' disabled' : ''
  return (
    <div
      onClick={disabled || !onClick ? null : _onClick}
      onKeyDown={e => {
        if (e.key === 'Enter' && !!onClick && !disabled) {
          _onClick()
        }
      }}
      role='button'
      tabIndex='0'
      className={_className}>
      <div className={`check${checked ? ' checked' : ''}${disabledClass}`}>
        {toggle && <span className='round-slider' />}
        <div
          className={`checkmark${check ? ' fas fa-check' : ''}${
            checked ? ' checked' : ''
          }`}
        />
        {transition && <div className='check-transition' />}
      </div>
      <span className='label'>{label}</span>
    </div>
  )
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox.js